import * as React from 'react';

const GoogleCalendar = (props) => (
  <svg
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 56.25 53"
    {...props}
  >
    <path
      d="M50 3.5h-4.42V1.25a1.25 1.25 0 0 0-2.5 0V3.5H29.12V1.25a1.25 1.25 0 0 0-2.5 0V3.5h-14V1.25a1.25 1.25 0 0 0-2.5 0V3.5H6.24A6.24 6.24 0 0 0 0 9.75v37A6.24 6.24 0 0 0 6.24 53H50a6.24 6.24 0 0 0 6.24-6.25v-37A6.24 6.24 0 0 0 50 3.5ZM6.24 6h3.88v2.83a1.25 1.25 0 0 0 2.5 0V6h14v2.83a1.25 1.25 0 0 0 2.5 0V6h14v2.83a1.25 1.25 0 0 0 2.5 0V6h4.42a3.74 3.74 0 0 1 3.74 3.75v7.33H2.5V9.75A3.74 3.74 0 0 1 6.24 6ZM50 50.5H6.24a3.74 3.74 0 0 1-3.74-3.75V19.58h51.24v27.17A3.74 3.74 0 0 1 50 50.5Z"/>
    <path
      d="M32.22 38.4v3.85h6.37a6.07 6.07 0 0 1-6.37 4.84 7.09 7.09 0 0 1 0-14.17 6.31 6.31 0 0 1 4.47 1.73l3.05-2.94a10.74 10.74 0 0 0-7.52-2.93 11.22 11.22 0 0 0 0 22.44c6.48 0 10.78-4.55 10.78-11a9.94 9.94 0 0 0-.18-1.86h-10.6Z"
      transform="translate(-3.88 -5.5)"
      style={{
        fillRule: 'evenodd',
      }}
    />
  </svg>
);

export default GoogleCalendar;
